import { useState } from "react";
import Breadcrumb from "../../Component/Breadcrumb";

const tabs = [
  { title: "Audio Visual Room", content: "" },
  {
    title: "Science Labs",
    content:
      "The school has well equipped science labs for physics, chemistry and biology with the latest apparatus to accommodate the students at a time. The basic purpose of the lab is to motivate children to convert their imagination into reality and to prepare them for life by instilling an approach to analyze problems and find solutions on their own.",
  },
  {
    title: "Smart Classes",
    content:
      "Our classrooms are converted into technology-enabled smart classrooms equipped with interactive Digital Board Systems. A powerful Smart Class Application Engine allows teachers to view and plan relevant digital content for their classroom sessions as per the syllabus. Thus, the students are given maximum chances to develop into challenging humans in this world.",
  },
  {
    title: "Computer Lab",
    content:
      "Computer science was introduced into the school curriculum in 1995 with the intention of accelerating a creative interest in modern technology and scientific knowledge. It is fully equipped with the latest state of the art, computer software, hardware and networking. It is actively used under the guidance of well qualified and experienced staff for imparting computer skills and knowledge to the students. School has separate computer lab for primary as well as higher section",
  },
  {
    title: "Library",
    content:
      "The School has a well-stocked, spacious library to quench the children's intellectual craving. The library helps the children to upgrade and update their knowledge and reinforce their classroom learning. The treasure trove of their knowledge and reinforce their classroom learning. The treasure trove of our library are illustrated encyclopedias, books, story books, selected daily newspapers weekly and monthly magazines and periodicals.",
  },
];

function Infrastructure() {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <>
      <Breadcrumb>About Us / Infrastructure</Breadcrumb>
      <div className="innersec">
        <div className="container">
          <div className="col-lg-12">
            <h1>Infrastructure</h1>
          </div>
          <div className="facilities_section ">
            <div className="facilities_wrapper">
              {/* Sidebar Tabs */}
              <div className="facilities_tabs">
                {tabs.map((tab, index) => (
                  <button
                    key={index}
                    className={`tab_button ${
                      activeTab === index ? "active" : ""
                    }`}
                    onClick={() => setActiveTab(index)}>
                    {tab.title}
                  </button>
                ))}
              </div>

              {/* Tab Content */}
              <div className="facilities_content">
                <h2>{tabs[activeTab].title}</h2>
                {tabs[activeTab].content ? (
                  <p>{tabs[activeTab].content}</p>
                ) : (
                  <p className="no-content">Content coming soon...</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Infrastructure;
